import { usePage } from '@kizi/comparator-core';
import { Button, ButtonProps } from '@kizi/core-components';
import React from 'react';

export const SkipButton = (props: ButtonProps) => {
  const { setState, state } = usePage();

  if (!setState || !state) return null;
  const onClick = () => {
    (state?.onCancel as Function)();
  };
  return <Button onClick={onClick} {...props} />;
};
